import React from "react"
import ErrorBoundary from "./src/components/ErrorBoundary"
import { trackPageView, setupLinkClickTracking } from "./src/utils/metaPixel"
import { captureVisitAttribution } from "./src/utils/visitAttribution"

import "./src/styles/global.css"
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/effect-fade"

let isInitialRouteUpdate = true

export const wrapRootElement = ({ element }) => {
  return <ErrorBoundary>{element}</ErrorBoundary>
}

export const onClientEntry = () => {
  setupLinkClickTracking()
  // ADR-180/183: referrer, UTM tags and ad click ids, read on the page a visit
  // lands on. They arrive with the landing URL, so a full page load is enough.
  captureVisitAttribution()
}

export const onRouteUpdate = () => {
  // The base Meta Pixel script in gatsby-ssr.js already fires a PageView on
  // initial load. Skip the first onRouteUpdate so we don't double-count it.
  if (isInitialRouteUpdate) {
    isInitialRouteUpdate = false
    return
  }

  trackPageView()
}
